import { resolveLambdaApiUrls } from '@/lib/lambdaProxyUrl';

/** Same-origin path (Vite dev proxy + Amplify Hosting rewrite → admin-users Lambda). */
export const ADMIN_USERS_API_PATH = '/api/admin-users';

export async function resolveAdminUsersUrls(): Promise<{
  proxyPath: string;
  directUrl: string;
} | null> {
  return resolveLambdaApiUrls({
    apiPath: ADMIN_USERS_API_PATH,
    customKey: 'adminUsersUrl',
    viteEnvKey: 'VITE_ADMIN_USERS_URL',
  });
}

export async function resolveAdminUsersUrl(): Promise<string | null> {
  const urls = await resolveAdminUsersUrls();
  return urls?.proxyPath ?? null;
}
